var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionGeneric',{attrs:{"to":_vm.to,"btnClasses":_vm.btnClasses,"btnClassesMobile":_vm.btnClassesMobile,"disabled":_vm.disabled,"label":"Modifica","iconClass":"fas fa-pencil-alt"}})}
var staticRenderFns = []

export { render, staticRenderFns }